// import { motion } from "framer-motion";
// import { Heart, Droplet, FlaskConical, PawPrint } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Navbar from './Navbar';
// import '../../../../src/styles/css/AnimalBloodBankHome.css';
// import heroImage from '../../../assets/ABB_background image1.png';

// export default function AnimalBloodBankHome() {
//   const navigate = useNavigate();

//   const handleRegisterClick = () => {
//     navigate('/register');
//   };

//   return (
//     <div className="blood-bank-container">
//       <Navbar />
//       {/* Hero Section */}
//       <section className="hero-section">
//         <div className="container">
//           <div className="hero-grid">
//             {/* Hero Text */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="hero-text"
//             >
//               <h1 className="hero-title">
//                 Animal Blood Bank
//               </h1>
//               <p className="hero-description">
//                 Connecting compassionate pet owners to save animal lives through blood donation and essential lab services.
//               </p>
//               <motion.button
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//                 className="cta-button"
//                 onClick={handleRegisterClick}
//               >
//                 Get Started
//               </motion.button>
//             </motion.div>

//             {/* Hero Image */}
//             <motion.div
//               initial={{ opacity: 0, scale: 0.95 }}
//               animate={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.8, delay: 0.2 }}
//               className="hero-image"
//             >
//               <img
//                 src={heroImage}
//                 alt="Dog and cat together"
//                 className="hero-img"
//               />
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="services-section">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//             className="section-header"
//           >
//             <h2 className="section-title">
//               Our Services
//             </h2>
//             <p className="section-description">
//               Comprehensive blood banking solutions for your beloved animals.
//             </p>
//           </motion.div>

//           <div className="services-grid">
//             {/* Service 1: Register Animal */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               whileHover={{ y: -8 }}
//               className="service-card"
//             >
//               <div className="service-icon">
//                 <PawPrint className="icon" />
//               </div>
//               <h3 className="service-title">
//                 Register Animal
//               </h3>
//               <p className="service-description">
//                 Add your pet to our database and access all blood bank services.
//               </p>
//             </motion.div>

//             {/* Service 2: Request Blood */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               whileHover={{ y: -8 }}
//               className="service-card"
//             >
//               <div className="service-icon">
//                 <Droplet className="icon" />
//               </div>
//               <h3 className="service-title">
//                 Request Blood
//               </h3>
//               <p className="service-description">
//                 Submit urgent blood requests for your animal in critical need.
//               </p>
//             </motion.div>

//             {/* Service 3: Become a Donor */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.3 }}
//               whileHover={{ y: -8 }}
//               className="service-card"
//             >
//               <div className="service-icon">
//                 <Heart className="icon" />
//               </div>
//               <h3 className="service-title">
//                 Become a Donor
//               </h3>
//               <p className="service-description">
//                 Register your healthy pet as a blood donor and save lives.
//               </p>
//             </motion.div>

//             {/* Service 4: Blood Typing */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5, delay: 0.4 }}
//               whileHover={{ y: -8 }}
//               className="service-card"
//             >
//               <div className="service-icon">
//                 <FlaskConical className="icon" />
//               </div>
//               <h3 className="service-title">
//                 Blood Typing
//               </h3>
//               <p className="service-description">
//                 Professional lab services to determine your animal's blood type.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Impact Section */}
//       <section className="impact-section">
//         <div className="container">
//           <div className="impact-content">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//             >
//               <h2 className="impact-title">
//                 Every Donation Saves Lives
//               </h2>
//               <p className="impact-description">
//                 Your pet can be a hero. Blood transfusions are critical for animals undergoing surgery, suffering from trauma, or battling disease. Join our network of compassionate donors making a difference every day.
//               </p>
//               <div className="stats-grid">
//                 <div className="stat">
//                   <div className="stat-number">500+</div>
//                   <div className="stat-label">Lives Saved</div>
//                 </div>
//                 <div className="stat">
//                   <div className="stat-number">200+</div>
//                   <div className="stat-label">Active Donors</div>
//                 </div>
//                 <div className="stat">
//                   <div className="stat-number">24/7</div>
//                   <div className="stat-label">Emergency Service</div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA Section */}
//       <section className="cta-section">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//             className="cta-content"
//           >
//             <h2 className="cta-title">
//               Ready to Make a Difference?
//             </h2>
//             <p className="cta-description">
//               Join our community of caring pet owners today.
//             </p>
//             <div className="cta-buttons">
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="cta-button-primary"
//                 onClick={handleRegisterClick}
//               >
//                 Register Your Pet
//               </motion.button>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// }






import { motion } from "framer-motion";
import {
  Heart,
  Droplet,
  FlaskConical,
  PawPrint,
  ShieldCheck,
  Search,
  ClipboardPlus,
  UserRound,
  Building2,
  Stethoscope,
  CheckCircle2,
  ArrowRight,
  PhoneCall,
  MapPin,
  Activity,
  Users,
  Clock3,
  BadgeCheck,
  AlertTriangle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "../../../../src/styles/css/AnimalBloodBankHome.css";
import heroImage from "../../../assets/ABB_background image1.png";

export default function AnimalBloodBankHome() {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const services = [
    {
      icon: PawPrint,
      title: "Register Animal",
      description:
        "Add animal details such as species, breed, age, weight, blood group, and location.",
    },
    {
      icon: FlaskConical,
      title: "Blood Typing",
      description:
        "Send blood typing requests to registered laboratories and update blood group records.",
    },
    {
      icon: Heart,
      title: "Become a Donor",
      description:
        "Register healthy animals as donors and help build a verified donor network.",
    },
    {
      icon: Droplet,
      title: "Request Blood",
      description:
        "Raise emergency blood requests and allow admins to identify compatible donors quickly.",
    },
  ];

  const workflowSteps = [
    {
      icon: UserRound,
      title: "Owner Registers",
      text: "Animal owners create an account and add their animals.",
    },
    {
      icon: FlaskConical,
      title: "Blood Group Verified",
      text: "Labs process blood typing requests when blood group is unknown.",
    },
    {
      icon: ShieldCheck,
      title: "Admin Approves Donor",
      text: "Admin verifies donor requests before adding them to the donor database.",
    },
    {
      icon: Search,
      title: "Match Donors",
      text: "System filters donors using species, breed, blood group, and location.",
    },
  ];

  const userTypes = [
    {
      icon: PawPrint,
      title: "Animal Owner",
      points: [
        "Register animals",
        "Request blood typing",
        "Apply as donor",
        "Raise emergency requests",
      ],
    },
    {
      icon: Building2,
      title: "Laboratory",
      points: [
        "View typing requests",
        "Process blood tests",
        "Update blood group",
        "Maintain lab records",
      ],
    },
    {
      icon: Stethoscope,
      title: "Admin",
      points: [
        "Approve donors",
        "Review blood requests",
        "Match compatible donors",
        "Monitor platform activity",
      ],
    },
  ];

  const faqs = [
    {
      q: "Why is an animal blood donor network needed?",
      a: "During emergencies, veterinary hospitals often do not have immediate access to verified donors. This platform reduces the time required to find compatible blood donors.",
    },
    {
      q: "Who approves donor animals?",
      a: "The Admin reviews donor applications and approves only eligible animals into the donor database.",
    },
    {
      q: "How are matching donors selected?",
      a: "The system compares species, breed, blood group, and other animal details to show compatible donors.",
    },
    {
      q: "Can one owner register multiple animals?",
      a: "Yes. One owner can register and manage multiple animals under the same account.",
    },
  ];

  return (
    <div className="blood-bank-container">
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-bg-glow hero-glow-one"></div>
        <div className="hero-bg-glow hero-glow-two"></div>

        <div className="container">
          <div className="hero-grid">
            <motion.div
              initial={{ opacity: 0, y: 26 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.75 }}
              className="hero-text"
            >
              <div className="hero-badge">
                <BadgeCheck size={18} />
                Centralized Animal Blood Donor Network
              </div>

              <h1 className="hero-title">
                Find Compatible Animal Blood Donors Faster During Emergencies
              </h1>

              <p className="hero-description">
                Animal Blood Bank connects animal owners, veterinary professionals,
                laboratories, and blood donors through a centralized donor database
                to help identify suitable animal blood donors during emergencies.
              </p>

              <div className="hero-actions">
                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  className="cta-button"
                  onClick={handleRegisterClick}
                >
                  Get Started
                  <ArrowRight size={18} />
                </motion.button>

                <button className="secondary-button" onClick={handleRegisterClick}>
                  Register as Donor
                </button>
              </div>

              <div className="hero-trust-row">
                <div className="trust-item">
                  <ShieldCheck size={18} />
                  Verified Donor Database
                </div>
                <div className="trust-item">
                  <Clock3 size={18} />
                  Emergency Workflow
                </div>
                <div className="trust-item">
                  <FlaskConical size={18} />
                  Lab Blood Typing
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.94 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.75, delay: 0.15 }}
              className="hero-image"
            >
              <div className="hero-card-floating top-card">
                <Droplet size={18} />
                <div>
                  <strong>Emergency Request</strong>
                  <span>Compatible donor search</span>
                </div>
              </div>

              <img
                src={heroImage}
                alt="Animal Blood Bank"
                className="hero-img"
              />

              <div className="hero-card-floating bottom-card">
                <Heart size={18} />
                <div>
                  <strong>Donor Network</strong>
                  <span>Verified animal donors</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="quick-stats-section">
        <div className="container">
          <div className="quick-stats-grid">
            <div className="quick-stat-card">
              <Users size={24} />
              <h3>Owners</h3>
              <p>Register and manage animals</p>
            </div>
            <div className="quick-stat-card">
              <Building2 size={24} />
              <h3>Labs</h3>
              <p>Process blood typing requests</p>
            </div>
            <div className="quick-stat-card">
              <Droplet size={24} />
              <h3>Donors</h3>
              <p>Verified eligible donor animals</p>
            </div>
            <div className="quick-stat-card">
              <Activity size={24} />
              <h3>Requests</h3>
              <p>Structured emergency workflow</p>
            </div>
          </div>
        </div>
      </section>

      {/* Problem Solution Section */}
      <section className="problem-section">
        <div className="container">
          <div className="problem-grid">
            <motion.div
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="problem-card danger-card"
            >
              <div className="section-mini-title">
                <AlertTriangle size={18} />
                The Current Problem
              </div>
              <h2>
                Finding animal blood donors during emergencies can be difficult.
              </h2>

              <p>
                Veterinary hospitals and animal owners may not have access to a
                centralized donor database when blood is urgently required. They
                often depend on personal contacts, community groups, NGOs, or
                social media to find suitable donors, which can delay treatment.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="problem-card solution-card"
            >
              <div className="section-mini-title">
                <CheckCircle2 size={18} />
                Our Solution
              </div>
              <h2>
                A centralized and verified animal blood donor database.
              </h2>
              <p>
                The platform helps animal owners register animals, laboratories
                process blood typing requests, and admins identify suitable
                eligible donors based on animal and blood information.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="section-header"
          >
            <span className="eyebrow">Platform Services</span>
            <h2 className="section-title">Everything Needed for Animal Blood Support</h2>
            <p className="section-description">
              From animal registration to donor matching, the platform creates a
              smooth workflow for emergency blood requirements.
            </p>
          </motion.div>

          <div className="services-grid">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <motion.div
                  key={service.title}
                  initial={{ opacity: 0, y: 22 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.08 }}
                  whileHover={{ y: -8 }}
                  className="service-card"
                >
                  <div className="service-icon">
                    <Icon className="icon" />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="workflow-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Workflow</span>
            <h2 className="section-title">How Animal Blood Bank Works</h2>
            <p className="section-description">
              A simple process that connects animal owners, laboratories, and admins.
            </p>
          </div>

          <div className="workflow-grid">
            {workflowSteps.map((step, index) => {
              const Icon = step.icon;
              return (
                <motion.div
                  key={step.title}
                  initial={{ opacity: 0, y: 22 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.08 }}
                  className="workflow-card"
                >
                  <div className="workflow-number">{index + 1}</div>
                  <div className="workflow-icon">
                    <Icon size={24} />
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* User Roles */}
      <section className="roles-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">System Users</span>
            <h2 className="section-title">Built for Owners, Labs, and Admins</h2>
            <p className="section-description">
              Each user has a clear role in building and maintaining the animal donor network.
            </p>
          </div>

          <div className="roles-grid">
            {userTypes.map((role, index) => {
              const Icon = role.icon;
              return (
                <motion.div
                  key={role.title}
                  initial={{ opacity: 0, y: 22 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.1 }}
                  className="role-card"
                >
                  <div className="role-icon">
                    <Icon size={28} />
                  </div>
                  <h3>{role.title}</h3>
                  <ul>
                    {role.points.map((point) => (
                      <li key={point}>
                        <CheckCircle2 size={16} />
                        {point}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Emergency Matching Section */}
      <section className="emergency-section">
        <div className="container">
          <div className="emergency-card">
            <motion.div
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="emergency-content"
            >
              <span className="eyebrow light">Emergency Blood Request</span>
              <h2>Faster donor matching when every minute matters.</h2>
              <p>
                When an owner raises a blood request, the admin can review the
                requirement and match eligible donors based on species, breed,
                blood group, and location.
              </p>

              <div className="emergency-points">
                <div>
                  <Search size={18} />
                  Compatible donor search
                </div>
                <div>
                  <MapPin size={18} />
                  Location-based donor visibility
                </div>
                <div>
                  <PhoneCall size={18} />
                  Owner contact for coordination
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="matching-preview"
            >
              <div className="match-card request-card">
                <h4>Requested Animal</h4>
                <p>Dog · Indian · O+</p>
                <span>Needs 1 unit blood</span>
              </div>

              <div className="match-arrow">
                <ArrowRight size={24} />
              </div>

              <div className="match-card donor-card">
                <h4>Matched Donor</h4>
                <p>Dog · Indian · O+</p>
                <span>Owner contact available</span>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="impact-section">
        <div className="container">
          <div className="impact-content">
            <motion.div
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <span className="eyebrow">Our Impact</span>
              <h2 className="impact-title">Every Verified Donor Can Save Lives</h2>
              <p className="impact-description">
                Blood transfusions are critical for animals undergoing surgery,
                trauma treatment, anemia care, and emergency medical procedures.
                A verified donor network can reduce delay and improve treatment outcomes.
              </p>

              <div className="stat">
                <div className="stat-number">01</div>
                <div className="stat-label">Centralized Donor Database</div>
              </div>

              <div className="stat">
                <div className="stat-number">03</div>
                <div className="stat-label">Platform User Roles</div>
              </div>

              <div className="stat">
                <div className="stat-number">01</div>
                <div className="stat-label">Emergency Blood Workflow</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">FAQ</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
          </div>

          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <motion.div
                key={faq.q}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.06 }}
                className="faq-card"
              >
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="cta-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="cta-content"
          >
            <h2 className="cta-title">Ready to Build a Life-Saving Donor Network?</h2>
            <p className="cta-description">
              Register your animal, request blood typing, or become part of the verified donor community.
            </p>

            <div className="cta-buttons">
              <motion.button
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                className="cta-button-primary"
                onClick={handleRegisterClick}
              >
                Register Now
                <ArrowRight size={18} />
              </motion.button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}